import base from './base';
import tnl from './tnl';
/* eslint-disable camelcase */
import tnl_com from './tnl_com';
import ngn from './ngn';
import wls from './wls';
import tls from './tls';
/* eslint-disable camelcase */
import tls_com from './tls_com';

export default base;
export const themes = {
  base,
  tnl,
  ngn,
  wls,
  tnl_com,
  tls,
  tls_com
};
